import { articles as coreArticles } from './seoBlogArticles'
import { part2Articles } from './seoBlogArticlesPart2'
import { part3Articles } from './seoBlogArticlesPart3'
import type { SEOArticle, ContentBlock } from './seoBlogArticles'

export const articles: SEOArticle[] = [
  ...coreArticles,
  ...part2Articles,
  ...part3Articles,
]

export const getArticleBySlug = (slug: string): SEOArticle | undefined => {
  return articles.find((article) => article.slug === slug)
}

export const getArticlesByCluster = (cluster: string): SEOArticle[] => {
  return articles.filter((article) => article.cluster === cluster)
}

export const getAllClusters = (): string[] => {
  return Array.from(new Set(articles.map((article) => article.cluster)))
}

export type { SEOArticle, ContentBlock }
